import { render, staticRenderFns } from "./earncoins.vue?vue&type=template&id=207fccb1&"
import script from "./earncoins.vue?vue&type=script&lang=ts&"
export * from "./earncoins.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports